import { Typography } from "@mui/material";
import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
    if (this.props.clearData) {
      this.props.clearData();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Typography variant="subtitle1" style={{ margin: "1rem", color: "grey", textAlign: "center" }}>
          {"Ein Fehler ist aufgetreten. :("}
        </Typography>
      );
    }

    return this.props.children;
  }
}
